import { axiosInstance } from ".";

export async function registerWebinar({
  webinarId,
  webinarCost,
  userTimeZone,
}: {
  webinarId: string;
  webinarCost: number;
  userTimeZone: string;
}) {
  return await axiosInstance.post("/credits/webinar", {
    webinarId,
    webinarCost,
    userTimeZone,
  });
}

export async function cancelWebinar({
  webinarId,
  userTimeZone,
}: {
  webinarId: string;
  userTimeZone: string;
}) {
  return await axiosInstance.post("/credits/webinar/cancel", {
    webinarId,
    userTimeZone,
  });
}

export const addToWaitingList = async ({contentId}: {contentId: string}) => {
  return axiosInstance.post("/content/waiting-list", { contentId });
};

export const removeFromWaitingList = async ({contentId}: {contentId: string}) => {
  return axiosInstance.delete("/content/waiting-list", { data: { contentId } });
};

export async function isUserOnWaitingList(platformContentId: string): Promise<boolean> {
    return (await axiosInstance.get(`/content/waiting-list/${platformContentId}`)).data;
  }
  
  
